export default __webpack_public_path__ + "static/media/concept3.8963e9b8.png";